import { Stack, Typography } from "@mui/material";

interface Props {
  label: string;
  value: string;
}

export function JournalSupportReadOnlyRow({ label, value }: Props) {
  return (
    <Stack direction="row" alignItems="center" py={1}>
      <Typography variant="body2" color="text.secondary" sx={{ width: 120, flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography variant="body2" fontWeight={600}>
        {value}
      </Typography>
    </Stack>
  );
}
